import { Controller } from "@hotwired/stimulus"

// Activa el botón submit en el form si hay al menos 1 checkbox tildado y muestra
// el conteo. Sirve para el bulk-confirm de purchase_invoice_uploads y se puede
// reutilizar en cualquier listado con checkboxes que se mandan al server como
// "ids[]".
export default class extends Controller {
  static targets = ["row", "submit", "count"]

  connect() {
    this.update()
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.rowTargets.forEach(cb => { cb.checked = checked })
    this.update()
  }

  update() {
    const n = this.rowTargets.filter(cb => cb.checked).length
    if (this.hasCountTarget) this.countTarget.textContent = n
    if (this.hasSubmitTarget) this.submitTarget.disabled = n === 0
  }
}
